/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InquiryChangeDto } from '../../models/inquiry-change-dto';
import { NotificationMessage } from '../../models/notification-message';

export interface ApiAgencyinquiryPut$Params {
  'api-version'?: string;
      body?: InquiryChangeDto
}

export function apiAgencyinquiryPut(http: HttpClient, rootUrl: string, params?: ApiAgencyinquiryPut$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiAgencyinquiryPut.PATH, 'put');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiAgencyinquiryPut.PATH = '/api/agencyinquiry';
